<template>
  <tooltip-custom :label-text="labelText">
    <icon-default :size="'small'">
      <IconEye v-if="isActive"/>
      <IconCopy v-else/>
    </icon-default>
  </tooltip-custom>
</template>

<script>
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import IconEye from "@/assets/icons/ui/eye.svg?inline";
import IconCopy from "@/assets/icons/ui/copy.svg?inline";
import TooltipCustom from "@/components/shared/TooltipCustom.vue";

export default {
  name: "ButtonShow",
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  components: {TooltipCustom, IconDefault, IconEye, IconCopy},
  computed: {
    labelText() {
      return this.isActive
          ? 'Опубликовано'
          : 'Не опубликовано'
    }
  }
}
</script>

<style scoped lang="scss">
  .btn-show-container {
    position: relative;
    width: fit-content !important;
    .label-container {
      pointer-events: none;
      white-space: nowrap;
      z-index: 1;
      right: 0;
      bottom: -40px;
      border-radius: 16px;
      padding: 6px 12px;
      position: absolute;
      background: var(--color-white-smoke);
      border: 1px solid var(--color-dark-purple);
      color: var(--color-dark-purple);
      font-size: 14px;
    }
  }
</style>